import styled from 'styled-components';
export var Description = styled.div.withConfig({
  displayName: "Description",
  componentId: "sc-f0hs11-0"
})(["overflow:hidden;font-size:14px;line-height:18px;color:", ";text-overflow:ellipsis;"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.fontL;
});